import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__classified_print_details',
    path: '/classifieds/print_details/:classifiedId/',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/classifieds/print/print-details.vue' /* webpackChunkName: "pages-print-print-details.vue" */
        )
      )
  }
]
